const Loader = () => {
  return (
    <>
      <style>
        {`
       .loading-spinner {
         display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100vh;
          position: fixed;
          top: 0;
          left: 0;
          z-index: 9999; /* Ensure it covers everything */
          pointer-events: auto; /* Enable pointer events on the overlay */
          background-color: rgba(255, 255, 255, 0.85); /* Opaque enough to hide content below */

      }
      .lds-ellipsis {
        display: inline-block;
        position: relative;
        width: 150px;
        height: 150px;
      }
      .lds-ellipsis div {
        position: absolute;
        top: 33px;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: black;
        animation-timing-function: cubic-bezier(0, 1, 1, 0);
      }
      .lds-ellipsis div:nth-child(1) {
        left: 8px;
        animation: lds-ellipsis1 0.6s infinite;
      }
      .lds-ellipsis div:nth-child(2) {
        left: 8px;
        animation: lds-ellipsis2 0.6s infinite;
      }
      .lds-ellipsis div:nth-child(3) {
        left: 32px;
        animation: lds-ellipsis2 0.6s infinite;
      }
      .lds-ellipsis div:nth-child(4) {
        left: 56px;
        animation: lds-ellipsis3 0.6s infinite;
      }
      @keyframes lds-ellipsis1 {
        0% {
          transform: scale(0);
        }
        100% {
          transform: scale(1);
        }
      }
      @keyframes lds-ellipsis3 {
        0% {
          transform: scale(1);
        }
        100% {
          transform: scale(0);
        }
      }
      @keyframes lds-ellipsis2 {
        0% {
          transform: translate(0, 0);
        }
        100% {
          transform: translate(24px, 0);
        }
      }
        `}
      </style>
      <div className="loading-spinner">
        <div className="lds-ellipsis">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </>
  );
};

export default Loader;
